import {createContext} from 'react';

export const WeekCardContext = createContext<{
  level: number;
  onRefresh: () => void;
}>({
  level: 0,
  onRefresh: () => {},
});
